<!-- Copyright (c) 2020-2021 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div>
    <BCard class="mb-5" data-testid="delete-panel">
      <div v-if="resourceIsCompany">
        <h5 class="card-title">
          {{ "Export Data" }}
        </h5>
        <p class="text-warning">
          {{ "Download will take some time to process" }}
        </p>
        <div style="display:flex;flex-direction:row;justify-content:flex-end">
          <BButton variant="primary" :disabled="isDisabled" @click="exportData('CompanyScript','companyID','Company Details')">
            {{ "Export Company" }}
          </BButton>
        </div>
      </div>

      <div v-if="resourceIsRole">
        <h5 class="card-title">
          {{ "Export Role" }}
        </h5>
        <p class="text-warning">
          {{ "Download will take some time to process" }}
        </p>
        <div style="display:flex;flex-direction:row;justify-content:flex-end">
          <BButton variant="primary" :disabled="isDisabled" @click="exportData('Role','roleID','Role Details')">
            {{ "Export Role" }}
          </BButton>
        </div>
      </div>
    
    <!-- <FrDeleteModal :custom-message="customModalMessage" :is-deleting="isDeleting"
      :translated-item-type="translatedItemType" @delete-item="deleteItem" /> -->
    </BCard>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
} from 'bootstrap-vue';
import axios from 'axios';
const ExcelJS = require('exceljs');
const FileSaver = require('file-saver');
import FrDeleteModal from '@forgerock/platform-shared/src/components/DeleteModal';
import NotificationMixin from '@forgerock/platform-shared/src/mixins/NotificationMixin';


/**
 * Generic delete panel shown in a Bootstrap card. Clicking the delete button
 * shows a modal for confirmation and emits an event delete-item on delete.
 */
export default {
  name: 'ExportPanel',
  data() {
    return {
      realmIsEA: (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
      isDisabled : false,
      isOpenidmAdmin: this.$store.state.UserStore.adminUser
    }
  },
  mixins: [
    NotificationMixin,
  ],
  components: {
    BButton,
    BCard,
    FrDeleteModal,
  },
  props: {
    /**
     * This is for export option to be enabled or disabled.
     */
    resourceIsCompany: {
      type: Boolean,
      default: false,
    },
    resourceIsRole: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    //Method to export Data

  async exportData(scriptName, entityID, excelName) {
  try {
    this.isDisabled = true;
    const urlpath = window.location.href;
    const Id = urlpath.substring(urlpath.lastIndexOf("/") + 1);
    const endpoint = `${this.realmIsEA ? 'eaExport' : 'export'}${scriptName}`;
    const url = `${process.env.VUE_APP_IDM_URL}/endpoint/${endpoint}?${entityID}=${Id}`;
    const response = await axios.get(url);
    const tableData = response.data.data;   
    const workbook = new ExcelJS.Workbook();
    this.createSheets(workbook, tableData);
    await this.saveWorkbook(workbook, excelName);
    
  } catch (error) {
    console.error(error);
    this.displayNotification('danger', "No matching privileges found");
  } finally {
    this.isDisabled = false;
  }
},

  createSheets(workbook, data) {
    for (const [key, value] of Object.entries(data)) {
      const sheet = workbook.addWorksheet(key);
      let headers = [];
      let headerValuesAdded = false;

      value?.forEach(innerValue => {
        const rowValues = [];
        Object.values(innerValue).forEach((currentObject, index) => {
          const cellKey = Object.keys(currentObject)[0];
          const cellValue = currentObject[cellKey];

          rowValues.push(cellValue);
          if (!headerValuesAdded) headers.push(cellKey);
        });

        if (!headerValuesAdded) {
          sheet.addRow(headers);
          headerValuesAdded = true;
        }
        sheet.addRow(rowValues);
      });

      sheet.getRow(1).font = { bold: true };
      this.autoAdjustColumnWidth(sheet);
    }
  },

  autoAdjustColumnWidth(sheet) {
    const upperLimit = 70;
    sheet.columns?.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: false }, cell => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) maxLength = columnLength;
      });
      column.alignment = { wrapText: true };
      column.width = maxLength > upperLimit ? upperLimit : maxLength;
    });
  },

  async saveWorkbook(workbook, fileType) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}|${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`;
    FileSaver.saveAs(blob, `${fileType} ${formattedDate}`);
  }
},
};
</script>
<style scoped>
.deleteButtonStyles {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  gap: 10px;
}
</style>